import styled from '@emotion/styled';

/**
 * 별을 그냥 아이콘으로만 두면 표시등인지 버튼인지 구분되지 않는다.
 * 커서·hover 배경·포커스 링으로 "누를 수 있는 것"임을 먼저 알린다.
 */
export const StarButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;

  transition: background-color 0.15s ease-in-out;

  &:hover,
  &:focus-visible {
    background-color: ${({ theme }) => theme.colors.zinc_100};
  }
`;
